<script>
import appConfig from "@/app.config";
import loadingVue from "@/components/loading.vue";

import axios from "axios";

export default {
  components: { loadingVue },
  page: {
    title: "Nilai Ujian",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "Nilai Ujian",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Nilai",
          active: true,
        },
      ],
      isLoading: true,
      setError: null,
      setScore: [],
      dataLatihan: [],
      dataValue: null,
      vert: null,
      listHasilUjian: [],
      listHasilUjianAkademik: [],
      listPaketSoal: [],
      detailSoal: [
        {
          paket: "Test Kecerdasan",
        },
        {
          paket: "Test Kepribadian",
        },
        {
          paket: "Test Kecermatan",
        },
      ],
    };
  },
  mounted() {
    this.getScore();
  },
  methods: {
    async getScore() {
      this.isLoading = true;
      await axios
        .get(
          process.env.VUE_APP_API_BASE_URL +
            "/api/get-scores?question_category_id=1&is_ujian=1"
        )
        .then((response) => {
          const transformedData = response.data.data.map((item) => ({
            id: item.id,
            nanoid: item.nanoid,
            user_id: item.user_id,
            package_id: item.package_id,
            question_category_id: item.question_category_id,
            is_exam: item.is_exam,
            is_ms: item.is_ms,
            amount_score: item.amount_score,
            exam_date: item.exam_date,
            created_at: item.created_at,
            updated_at: item.updated_at,
            question_category: item.question_category,
            package: item.package,
            student_scores: item.student_score_subjects.flatMap((subject) =>
              subject.student_score_subject_details.map((detail) => ({
                id: detail.id,
                nanoid: detail.nanoid,
                question_sub_category: {
                  id: subject.question_sub_category.id,
                  name: subject.question_sub_category.name,
                },
                student_score_subject_id: subject.id,
                soal_id: detail.soal_id,
                score_detail: detail.score_detail,
                grade: detail.grade,
                is_ms_detail: detail.is_ms_detail,
                amount_wrong_detail: detail.amount_wrong_detail,
                amount_correct_detail: detail.amount_correct_detail,
                answered_questions_detail: detail.answered_questions_detail,
                number_of_questions_detail: detail.number_of_questions_detail,
                created_at: detail.created_at,
                updated_at: detail.updated_at,
                soals: detail.soals,
              }))
            ),
          }));

          this.setScore = transformedData;
          this.isLoading = false;
        })
        .catch((error) => {
          this.setError = error.response.data.error;
          this.$store.commit("setError", error.response.data.error);
          console.log(error);
        })
        .finally(() => (this.isLoading = false));
    },

    printCertificate() {
      window.open(
        process.env.VUE_APP_API_BASE_URL +
          `/export/certificate?question_category_id=1&is_ujian=1&user_id=${this.$store.getters.getLoggedInUserId}`
      );
    },
  },
  middleware: "authentication",
};
</script>

<template>
  <div>
    <div v-if="isLoading" class="container-fluid">
      <loading-vue style="padding: 5%;"></loading-vue>
    </div>

    <template v-else>
      <template v-if="setError">
        <div class="my-5 text-center">
          <p class="fs-3">
            <strong>{{ setError }} Silahkan hubungi admin.</strong>
          </p>
        </div>
      </template>

      <template v-else-if="setScore.length === 0">
        <div class="my-5 text-center">
          <p><strong>Tidak ada nilai saat ini.</strong></p>
        </div>
      </template>

      <template v-else>
        <div
          class="table-responsive"
          v-for="(score, index) in setScore"
          :key="index"
        >
          <table class="table table-striped table-bordered">
            <thead>
              <tr class="bg-secondary">
                <th colspan="13">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <span class="text-white text-uppercase fs-5">
                      {{ score.package.name }}
                    </span>

                    <b-button
                      v-if="index === 0"
                      block
                      variant="purple"
                      class="d-flex align-items-center gap-2"
                      @click="printCertificate()"
                      style="font-size: 14px;padding-left: 20px !important;padding-right: 20px !important;"
                    >
                      <b-icon-printer></b-icon-printer>
                      Cetak Sertifikat
                    </b-button>
                  </div>
                </th>
              </tr>

              <tr>
                <th
                  class="text-center"
                  v-for="detail in score.student_scores"
                  :key="detail.id"
                  colspan="4"
                >
                  <span class="text-uppercase">
                    {{
                      detail.question_sub_category.name === "kecermatan"
                        ? "Sikap Kerja"
                        : detail.question_sub_category.name
                    }}
                    -
                  </span>
                  <span
                    class="border border-2 rounded-pill px-2 py-1"
                    style="font-size: 12px; color: #333;"
                    >Soal ID {{ detail.soal_id }}</span
                  >
                </th>
              </tr>

              <tr>
                <th
                  class="text-center"
                  v-for="detail in score.student_scores"
                  :key="detail.id"
                  colspan="4"
                >
                  Jumlah
                </th>
              </tr>

              <tr>
                <th
                  v-for="detail in score.student_scores"
                  :key="detail.id"
                  colspan="4"
                  class="border"
                  style="padding: 0;margin: 0;"
                >
                  <table class="table" style="padding: 0;margin: 0;">
                    <tr class="border">
                      <th class="text-center border border-r-1 w-25 p-3">
                        Soal
                      </th>
                      <th
                        v-if="
                          detail.question_sub_category.name !== 'kepribadian'
                        "
                        class="text-center border border-r-1 w-25 p-3"
                      >
                        Benar
                      </th>
                      <th
                        v-if="
                          detail.question_sub_category.name !== 'kepribadian'
                        "
                        class="text-center border border-r-1 w-25 p-3"
                      >
                        Salah
                      </th>
                      <th
                        v-if="
                          detail.question_sub_category.name === 'kepribadian'
                        "
                        class="text-center border border-r-1 w-25 p-3"
                      >
                        Score
                      </th>
                      <th class="text-center border border-r-1 w-25 p-3">
                        Nilai
                      </th>
                    </tr>
                  </table>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td
                  v-for="detail in score.student_scores"
                  :key="detail.id"
                  colspan="4"
                  class="border"
                  style="padding: 0;margin: 0;"
                >
                  <table class="table" style="padding: 0;margin: 0;">
                    <tr class="border">
                      <td class="text-center border border-r-1 w-25 p-3">
                        {{ detail.number_of_questions_detail }}
                      </td>
                      <td
                        v-if="
                          detail.question_sub_category.name !== 'kepribadian'
                        "
                        class="text-center border border-r-1 w-25 p-3"
                      >
                        {{ detail.amount_correct_detail }}
                      </td>
                      <td
                        v-if="
                          detail.question_sub_category.name !== 'kepribadian'
                        "
                        class="text-center border border-r-1 w-25 p-3"
                      >
                        {{ detail.amount_wrong_detail }}
                      </td>
                      <td
                        v-if="
                          detail.question_sub_category.name === 'kepribadian'
                        "
                        class="text-center border border-r-1 w-25 p-3"
                      >
                        {{ detail.grade }}
                      </td>
                      <td class="text-center border border-r-1 w-25 p-3">
                        {{ detail.score_detail }}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </tbody>

            <tfoot>
              <tr>
                <td colspan="13" class="text-center">
                  <div
                    v-if="score.is_ms"
                    class="my-2 d-flex justify-content-center align-items-center p-3 rounded border"
                    style="background-color: #dcfce7; border-color: #bbf7d0; color: #22c55e;"
                  >
                    <p class="m-0" style="font-size: 15px;">
                      Selamat! nilai kamu {{ score.amount_score }} pada ujian
                      {{ score.package.name }} telah Memenuhi Syarat

                      <span class="fw-bold ml-2" style="color: #16a34a;">
                        (MS)
                      </span>
                    </p>
                  </div>
                  <div
                    v-else
                    class="my-2 d-flex justify-content-center align-items-center p-3 rounded border"
                    style="background-color: #fee2e2; border-color: #fecaca; color: #ef4444;"
                  >
                    <p class="m-0">
                      Nilai kamu {{ score.amount_score }} pada ujian
                      {{ score.package.name }} Tidak Memenuhi Syarat
                      <span class="fw-bold" style="color: #dc2626;">
                        (TMS)
                      </span>
                    </p>
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </template>
    </template>
  </div>
</template>
